import React from 'react';
import i4 from '../../assets/i4.jpg';
import i5 from '../../assets/i5.jpg';
import i6 from '../../assets/i6.jpg';
import i7 from '../../assets/i7.jpg';



const B4 = () => {
  return (
    <div className='page1'>
    <div className='overall'>
      <h2 className='heading'>தாய்ப்பால் ஊட்டுதல்</h2>
      <h3 className='subheading'>தாய்ப்பால் ஊட்டுவதற்கான அடிப்படை முறைகள்</h3>

    </div>
      <div className='answer'>

<h3  style={{ color: '#BB0297' }}>தாய்ப்பால் கொடுக்கும் சரியான நிலைகள்:-</h3><br />


<h4  style={{ color: '#BB0297' }}>பந்து நிலை (ஃபுட்பால் பொசிஷன்):</h4>
<img src={i4}  className='image' alt=""/>

<p>குழந்தையை பந்தைப் பிடிப்பதுபோல உள்ளங்கையில் தலையையும் சேர்த்துப் பிடிக்க வேண்டும். கழுத்துடன்

குழந்தையின் உடலை முன்னங்கையால் சற்று உயர்த்திப் பிடித்துக்கொண்டு, குழந்தையின் உடல் தாயின் அக்குள் பகுதியையொட்டிய பகுதியில் இருக்குமாறு அணைத்துக்கொண்டு பால் புகட்ட வேண்டும்.

சிசேரியன் அறுவைசிகிச்சை செய்தவர்களுக்கும் இரட்டைக் குழந்தை பெற்றவர்கள் இரண்டு குழந்தைகளுக்கும் ஒரே நேரத்தில் பால் கொடுக்க இந்த முறை உதவும்.
</p>
<br /><br />
<h4  style={{ color: '#BB0297' }}>தொட்டில் நிலை (கிரேடில் பொசிஷன்):</h4>
<img src={i5}  className='image' alt=""/>

<p>இரண்டு கைகளையும் மார்பை ஒட்டி தொட்டில் போல் கைகளை கட்டியிருக்க வேண்டும்.

குழந்தையை முன்னங்கையில் மென்மையாக கிடத்தி கொண்டு குழந்தையின் தலையை முழங்கைகளை வளைத்து அந்த இடத்தில் வைத்தபடி அணைக்கவேண்டும்.

குழந்தையின் தாடை முழங்கையில் ஒட்டி இருக்க வேண்டும்.</p>
<br /><br />

<h4  style={{ color: '#BB0297' }}>குறுக்குத் தொட்டில் நிலை (கிராஸ் கிரேடில் பொசிஷன்):</h4>
<img src={i6}  className='image' alt=""/>

<p>
  <ul>
    <li>ஒரு கையில் உள்ளங்கையில் குழந்தையின் தலையை மென்மையாக பிடித்திருக்க வேண்டும். </li>

<li>பெருவிரல் குழந்தையின் ஒரு காது பகுதியையும் மற்ற நான்கு விரல்கள் அடுத்த பக்கத்தின் காது முனையையும் பிடித்திருக்கும்படி வைக்கவேண்டும்.</li>

<li>மற்றொருகையால் மார்பகத்தை பிடித்தபடி பால் புகட்ட வேண்டும்.</li>
</ul>
</p>
<br /><br />

<h4  style={{ color: '#BB0297' }}>பக்க சாய்வு நிலை (சைடு லையிங் பொசிஷன்):</h4>
<img src={i7}  className='image' alt=""/>

குழந்தையை மார்புக்கு அருகில் அணைத்து படுத்து தாய் தலை முதல் கழுத்து வரை உடலை மேலே தூக்கி குழந்தையை அணைத்த நிலையில் பால் புகட்ட வேண்டும்.

இந்த நிலை பொதுவாக அதிக ரத்தபோக்கு கொண்ட தாய்க்கும், சிசேரியன் பிரசவம் நடந்தவர்களுக்கும், வலி மிகுந்த பிரசவம் செய்துகொண்டவர்களுக்கும் ஏற்ற முறை.<br></br>
    </div>
    </div>      
     
   
  );
};

export default B4
